import axios from 'axios';
import { FacebookPage, FacebookPostData } from '../types/facebook.types';
import { debug } from "../../../../../utils/debugLogger";
import {
  getFacebookRedirectUri,
} from '../../../config/metaEnv';
import { exchangeOAuthCode } from "../../../../../services/oauthTokenExchange";

interface FacebookAuthResponse {
  access_token: string;
  email: string;
  pages: FacebookPage[];
}

export const handleFacebookCallback = async (code: string): Promise<FacebookAuthResponse> => {
  if (!code) {
    throw new Error('Authorization code is required');
  }

  try {
    const redirectUri = getFacebookRedirectUri();
    // Exchanged on the server: the app secret never reaches the browser.
    const tokenData = await exchangeOAuthCode<{ access_token: string }>("meta", code, redirectUri);
    const access_token = tokenData.access_token;

   // Get user profile first
    const userResponse = await axios.get('https://graph.facebook.com/me', {
      params: {
        fields: 'id,name,email',
        access_token,
      }
    });
    

    // Create a personal profile page object
    const personalProfile = {
      id: userResponse.data.id,
      name: userResponse.data.name,
      access_token: access_token,
      category: 'personal_profile',  // Special category for personal profile
    };


    // Get pages
    const pagesResponse = await axios.get('https://graph.facebook.com/me/accounts', {
      params: {
        access_token,
        // Do NOT request the `business` field: it requires the business_management
        // permission, which the Facebook connect scope does not include. External users
        // who never granted business_management get a 403 "(#200) Requires
        // business_management permission to manage the object" on /me/accounts, which
        // previously bubbled up to the global 401/403 interceptor and force-logged them
        // out ("Sign in required"). The connect flow does not use `business`.
        fields: 'name,access_token,category,page_type,verification_status,category_list,tasks,id',
        limit:100
      }
    });

     // Combine personal profile with pages
    const pages = [personalProfile, ...pagesResponse.data.data];
    // Log page categories for debugging
  return {
      access_token,
      email: userResponse.data.email,
      pages,
    };
  } catch (error: any) {
    // Do not log request params — they carry the OAuth client_secret / access_token.
    debug.error('Facebook API Error:', {
      message: error.message,
      response: error.response?.data,
      url: error.config?.url,
    });
    throw error;
  }
};
export const testFacebookPost = async ({ pageId, pageAccessToken, message }: FacebookPostData): Promise<any> => {
  try {
    const response = await axios.post(
      `https://graph.facebook.com/${pageId}/feed`,
      null,
      {
        params: {
          message,
          access_token: pageAccessToken,
        },
      }
    );
    
    return response.data;
  } catch (error) {
    debug.error('Error posting to Facebook:', error);
    throw error;
  }
};